/* Lane Linen — "Complete your set" upsell.
   - Interactive colour + size picker on the product page (fed by embedded JSON).
   - Add-to-cart via Dawn's /cart/add.js with cart-drawer refresh.
   Uses event delegation so it survives the cart drawer re-rendering. Guarded to
   attach global listeners only once. */
(function () {
  "use strict";

  /* i18n: window.LL_T (snippets/ll-js-i18n.liquid) maps English UI text to the
     current language; English is the fallback. */
  var LLT = window.LL_T || {};
  function llT(s, n) { var t = LLT[s] || s; return n != null ? t.replace("{n}", n) : t; }
  if (window.__lluInit) return;
  window.__lluInit = true;

  function norm(s) { return String(s || "").toLowerCase().replace(/[^a-z0-9]/g, ""); }
  function isWhite(hex) {
    var h = String(hex || "").trim().toLowerCase().replace(/\s/g, "");
    return h === "#ffffff" || h === "#fff" || h === "ffffff" || h === "fff" || h === "";
  }

  /* ---------- cart refresh (shared) ---------- */
  function refreshDrawer(res) {
    if (res && res.sections) {
      if (res.sections["cart-drawer"]) {
        var d = document.querySelector("cart-drawer");
        if (d) {
          var parsed = new DOMParser().parseFromString(res.sections["cart-drawer"], "text/html");
          var fresh = parsed.querySelector("cart-drawer .drawer__inner") || parsed.querySelector("cart-drawer");
          var target = d.querySelector(".drawer__inner");
          if (fresh && target) target.innerHTML = fresh.innerHTML;
          d.classList.remove("is-empty");
          if (typeof d.open === "function") d.open();
        }
      }
      if (res.sections["cart-icon-bubble"]) {
        var bubble = document.getElementById("cart-icon-bubble");
        if (bubble) {
          var pb = new DOMParser().parseFromString(res.sections["cart-icon-bubble"], "text/html");
          var nb = pb.querySelector("#cart-icon-bubble") || pb.body.firstElementChild;
          if (nb) bubble.innerHTML = nb.innerHTML;
        }
      }
    } else {
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    }
    initAll();
  }

  /* ---------- add to cart (delegated) ---------- */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest ? e.target.closest("[data-llu-add]") : null;
    if (!btn) return;
    var root = btn.closest("[data-llu-root]");
    if (!root) return;
    var variantEl = root.querySelector("[data-llu-variant]");
    var id = variantEl && variantEl.value;
    if (!id || btn.disabled) return;
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = llT("Adding…");
    var wantsSections = !!document.querySelector("cart-drawer");
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : "/cart/add") + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: wantsSections ? ["cart-drawer", "cart-icon-bubble"] : undefined })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) { btn.textContent = llT("Added ✓"); refreshDrawer(res); setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1600); })
      .catch(function () { btn.textContent = llT("Try again"); setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1600); });
  });

  /* close any open dropdown on outside click */
  document.addEventListener("click", function (e) {
    document.querySelectorAll("[data-llu-dd] [data-llu-dd-menu]").forEach(function (menu) {
      var dd = menu.closest("[data-llu-dd]");
      if (dd && !dd.contains(e.target)) {
        menu.hidden = true;
        var b = dd.querySelector("[data-llu-dd-btn]"); if (b) b.setAttribute("aria-expanded", "false");
      }
    });
  });

  /* ---------- interactive picker ---------- */
  function initPicker(root) {
    if (root.dataset.lluReady) return;
    var dataEl = root.querySelector("[data-llu-data]");
    if (!dataEl) return;
    var colors;
    try { colors = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!colors || !colors.length) return;
    root.dataset.lluReady = "1";

    var el = {
      img: root.querySelector("[data-llu-img]"),
      price: root.querySelector("[data-llu-price]"),
      colorName: root.querySelector("[data-llu-colorname]"),
      variant: root.querySelector("[data-llu-variant]"),
      links: root.querySelectorAll("[data-llu-link]"),
      colorDd: root.querySelector('[data-llu-dd="color"]'),
      sizeDd: root.querySelector('[data-llu-dd="size"]'),
      swatch: root.querySelector("[data-llu-dd-swatch]"),
      sizeLabel: root.querySelector("[data-llu-dd-label]")
    };

    // default colour = the one matching the current product.
    // Exact normalized match first; then a prefix match either direction so
    // e.g. sheet "Windowpane" -> pillow "Windowpane-Charcoal" and
    // "Ticking Stripe" -> "Ticking Stripe-Cobalt Blue" still line up.
    var want = norm(root.dataset.defaultColor);
    var ci = -1;
    for (var i = 0; i < colors.length; i++) { if (norm(colors[i].name) === want) { ci = i; break; } }
    if (ci === -1 && want) {
      for (var j = 0; j < colors.length; j++) {
        var cn = norm(colors[j].name);
        if (cn && (cn.indexOf(want) === 0 || want.indexOf(cn) === 0)) { ci = j; break; }
      }
    }
    if (ci === -1) ci = 0;
    var si = 0;

    function swatchStyle(c, node) {
      if (isWhite(c.hex) && c.img) { node.style.backgroundImage = "url('" + c.img + "')"; node.classList.add("llu__dd-swatch--img"); node.style.backgroundColor = ""; }
      else { node.style.backgroundColor = c.hex || "#e6e2d6"; node.style.backgroundImage = ""; node.classList.remove("llu__dd-swatch--img"); }
    }

    function firstAvailable(c) {
      for (var k = 0; k < c.variants.length; k++) { if (c.variants[k].available) return k; }
      return 0;
    }

    function buildColorMenu() {
      var menu = el.colorDd.querySelector("[data-llu-dd-menu]");
      menu.innerHTML = "";
      colors.forEach(function (c, idx) {
        var opt = document.createElement("button");
        opt.type = "button";
        opt.className = "llu__dd-opt" + (idx === ci ? " is-active" : "");
        var sw = document.createElement("span");
        sw.className = "llu__dd-swatch";
        swatchStyle(c, sw);
        opt.appendChild(sw);
        opt.appendChild(document.createTextNode(c.name));
        opt.addEventListener("click", function () { ci = idx; si = firstAvailable(colors[ci]); if (sizeMap) followPageSize(); closeAll(); render(); buildColorMenu(); buildSizeMenu(); });
        menu.appendChild(opt);
      });
    }

    function buildSizeMenu() {
      var menu = el.sizeDd.querySelector("[data-llu-dd-menu]");
      menu.innerHTML = "";
      colors[ci].variants.forEach(function (v, idx) {
        var opt = document.createElement("button");
        opt.type = "button";
        opt.className = "llu__dd-opt" + (idx === si ? " is-active" : "") + (v.available ? "" : " is-disabled");
        opt.textContent = v.title + (v.available ? "" : " — sold out");
        if (v.available) opt.addEventListener("click", function () { si = idx; closeAll(); render(); buildSizeMenu(); });
        else opt.disabled = true;
        menu.appendChild(opt);
      });
    }

    function render() {
      var c = colors[ci];
      var v = c.variants[si] || c.variants[0];
      if (el.img && c.img) el.img.src = c.img;
      if (el.price) el.price.textContent = v ? v.price : "";
      if (el.colorName) el.colorName.textContent = c.name;
      if (el.swatch) swatchStyle(c, el.swatch);
      if (el.sizeLabel) el.sizeLabel.textContent = v ? v.title : llT("Size");
      if (el.variant) el.variant.value = v && v.available ? v.id : "";
      el.links.forEach(function (a) { a.setAttribute("href", c.url); });
      var addBtn = root.querySelector("[data-llu-add]");
      if (addBtn) { addBtn.disabled = !(v && v.available); }
    }

    function closeAll() {
      root.querySelectorAll("[data-llu-dd-menu]").forEach(function (m) { m.hidden = true; });
      root.querySelectorAll("[data-llu-dd-btn]").forEach(function (b) { b.setAttribute("aria-expanded", "false"); });
    }

    root.querySelectorAll("[data-llu-dd]").forEach(function (dd) {
      var btn = dd.querySelector("[data-llu-dd-btn]");
      var menu = dd.querySelector("[data-llu-dd-menu]");
      btn.addEventListener("click", function (e) {
        e.stopPropagation();
        var open = !menu.hidden;
        closeAll();
        if (!open) { menu.hidden = false; btn.setAttribute("aria-expanded", "true"); }
      });
    });

    si = firstAvailable(colors[ci]);

    // Optional sheet-size -> upsell-size map (flannel: Full -> Queen blanket, etc.).
    // Follows the size picked on the page; a sold-out match keeps the current size.
    var sizeMap = null;
    try { sizeMap = root.dataset.sizeMap ? JSON.parse(root.dataset.sizeMap) : null; } catch (e) { sizeMap = null; }
    var info = root.closest("product-info") || document;
    function pageSize() {
      var checked = info.querySelectorAll('variant-selects input[type="radio"]:checked');
      for (var k = 0; k < checked.length; k++) {
        if (/size/i.test(checked[k].name || "")) return checked[k].value;
      }
      return checked.length ? checked[0].value : "";
    }
    function followPageSize() {
      var want = sizeMap[pageSize()];
      if (!want) return;
      var vs = colors[ci].variants;
      for (var k = 0; k < vs.length; k++) {
        if (vs[k].title === want && vs[k].available) { si = k; break; }
      }
    }
    if (sizeMap) {
      followPageSize();
      var resync = function () { setTimeout(function () { followPageSize(); render(); buildSizeMenu(); }, 0); };
      info.addEventListener("change", resync);
      if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
        subscribe(PUB_SUB_EVENTS.variantChange, resync);
      }
    }

    buildColorMenu();
    buildSizeMenu();
    render();
  }

  function initAll() {
    document.querySelectorAll("[data-llu-picker]").forEach(initPicker);
  }

  // Re-hydrate the cart-drawer picker after any drawer re-render (Dawn replaces its HTML).
  function observeCartDrawer() {
    var d = document.querySelector("cart-drawer");
    if (!d || d.__lluObserved) return;
    d.__lluObserved = true;
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(initAll, 60);
    }).observe(d, { childList: true, subtree: true });
  }

  function boot() { initAll(); observeCartDrawer(); }
  if (document.readyState !== "loading") boot();
  else document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", boot);
})();
